export function getFocusableElements(element: Element | null) {
  if (!element) {
    return;
  }

  // Get all elements that can be focusable
  const focusableElements = Array.from(
    element.querySelectorAll<HTMLElement>(
      'a, button, input, textarea, select, details, [tabindex]',
    ),
  )
    // remove any element that have a tabIndex of -1
    .filter((element) => element.tabIndex > -1)
    // remove hidden elements
    .filter(
      (element) =>
        element.offsetParent !== null &&
        element.checkVisibility({
          visibilityProperty: true,
          opacityProperty: true,
        }),
    );

  return focusableElements;
}

export function loadScript(
  src: string,
  position: HTMLElement | null = document.body,
  id = '',
) {
  if (!position) {
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}

/**
 * Converts px number value to rem number value.
 * Uses document object to access font size.
 */
export const convertNumberToRemNumber = (value: number): number => {
  const documentFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  return (1 / documentFontSize) * value;
};
